module.exports = __webpack_public_path__ + "img/check.9384aafe.svg";